<div class="payment a-fx-col a-fx-gap-32" [class.payment-new]="newSubscription">
    <div class="a-fx-none a-fx-col a-fx-gap-24">
        <div class="h3">
            <ng-container *ngIf="replace">
                {{ 'settings.payment-methods.replace-payment' | translate }}
            </ng-container>

            <ng-container *ngIf="!secondary && !replace">
                {{ 'settings.payment-methods.set-up-payment' | translate }}
            </ng-container>

            <ng-container *ngIf="secondary">
                {{ 'settings.payment-methods.backup-payment' | translate }}
            </ng-container>
        </div>

        <p [innerHTML]="'settings.payment-methods.set-up-payment-message' | translate"></p>
    </div>

    <adspt-payment-methods-new [alwaysDefault]="true" [newSubscription]="newSubscription"></adspt-payment-methods-new>
</div>

<ng-container
    [adsptHeap]="replace ? 'subscription-payment-replace' : 'subscription-payment-add'"
    [useParent]="true"
    [debounceResolve]="true"
    [elementPath]="{ parent: '.ant-modal-content', child: '.ant-modal-footer .ant-btn-primary' }"
/>
<ng-container
    adsptHeap="subscription-payment-cancel"
    [useParent]="true"
    [debounceResolve]="true"
    [elementPath]="{ parent: '.ant-modal-content', child: '.ant-modal-footer .ant-btn' }"
/>
